import { Injectable } from '@angular/core';
import { LanguageService, SupportedLanguages } from './language.service';
import { AuthService } from '../_services/auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LinkOpenerService {
  private activeLanguage: SupportedLanguages = SupportedLanguages.GERMAN;

  constructor(
    private languageService: LanguageService,
    private authService: AuthService,
  ) {
    languageService.activeLanguage$.subscribe({
      next: (language) => {
        this.activeLanguage = language;
      },
    });
  }

  public openMyBFHLink(url: string) {
    // Not a MyBFHLink
    if (
      !url.startsWith('https://bernerfachhochschule.sharepoint.com/sites/mybfh')
    ) {
      window.open(url, '_blank');
      return;
    }

    if (this.authService.isStud()) {
      const languageId: Record<string, string> = {
        de: 'b2b59de3-fb82-4c58-97d1-3865bbe22d31',
        en: 'c9d4f972-f563-4f8c-9373-ae77dd455e06',
        fr: '05c57548-de90-4c67-9e30-cfed0a188d56',
      };

      const id = languageId[this.activeLanguage] ?? languageId['de'];
      const encodedPayload = encodeURIComponent(JSON.stringify({ id }));
      const url = environment.campusAppBaseUrl + encodedPayload;

      window.open(url, '_blank');
      return;
    } else {
      // GERMAN
      if (this.activeLanguage === SupportedLanguages.GERMAN) {
        window.open(url, '_blank');
        return;
      }

      // Other Languages
      const localizedUrl = url.replace(
        /-de(?=$|\/|\/SitePages\/)/,
        `-${this.activeLanguage}`,
      );
      window.open(localizedUrl, '_blank');
    }
  }
}
